/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Implementer_InactiveInputs */

const vi_care_log_implementer_inactive = /** @type {(inputs: Care_Log_Implementer_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người dùng (đã nghỉ)`)
};

/**

* @param {Care_Log_Implementer_InactiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_implementer_inactive = /** @type {((inputs?: Care_Log_Implementer_InactiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Implementer_InactiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_implementer_inactive(inputs)
});